
import api from '@js/api';

export default {
	namespaced: true,

	state: {
		cart: null
	},

	getters: {
		getCart(state) {
			return state.cart;
		}
	},

	mutations: {
		updateCart(state, payload) {
			state.cart = payload;
		}
	},

	actions: {
		async getCart(context) {
			const cart = (await api.getCart()).data;
			context.commit('updateCart', cart);
		},

		async updateItemQuantity(context, { id, quantity }) {
			const cart = (await api.updateCartOfferQuantity({ id, quantity })).data;
			// cart.order_offers[0].quantity = 1;
			context.commit('updateCart', cart);
		},

		async removeItem(context, itemId) {
			const cart = (await api.removeOfferFromCart(itemId)).data;
			context.commit('updateCart', cart);
		},

		async applyCoupon(context, couponCode) {
			const cart = (await api.addCouponToCart(couponCode)).data;
			context.commit('updateCart', cart);
		},

		async updateShipping(context, shippingId) {
			const cart = (await api.setShippingCategory(shippingId)).data;
			context.commit('updateCart', cart);
		}
	}
};
